// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file events/v1/install_event.proto (package events.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file events/v1/install_event.proto.
 */
export const file_events_v1_install_event: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ch1ldmVudHMvdjEvaW5zdGFsbF9ldmVudC5wcm90bxIJZXZlbnRzLnYxInYKDEluc3RhbGxFdmVudBIOCgZkb21haW4YASABKAkSFAoMYWNjZXNzX3Rva2VuGAIgASgJEhcKCnJlZmVyYWxfaWQYAyABKAlIAIgBARIQCgN0aWQYBCABKAlIAYgBAUINCgtfcmVmZXJhbF9pZEIGCgRfdGlkQm0KDWNvbS5ldmVudHMudjFCEUluc3RhbGxFdmVudFByb3RvUAFaBC4vcGKiAgNFWFiqAglFdmVudHMuVjHKAglFdmVudHNcVjHiAhVFdmVudHNcVjFcR1BCTWV0YWRhdGHqAgpFdmVudHM6OlYxYgZwcm90bzM'
    );

/**
 * @generated from message events.v1.InstallEvent
 */
export type InstallEvent = Message<'events.v1.InstallEvent'> & {
    /**
     * @generated from field: string domain = 1;
     */
    domain: string;

    /**
     * @generated from field: string access_token = 2;
     */
    accessToken: string;

    /**
     * @generated from field: optional string referal_id = 3;
     */
    referalId?: string | undefined;

    /**
     * @generated from field: optional string tid = 4;
     */
    tid?: string | undefined;
};

/**
 * Describes the message events.v1.InstallEvent.
 * Use `create(InstallEventSchema)` to create a new message.
 */
export const InstallEventSchema: GenMessage<InstallEvent> = /*@__PURE__*/ messageDesc(file_events_v1_install_event, 0);
